/* eslint-disable */
import { Navigate } from 'react-router-dom';
import DmtTable from './bankingServices/money transfer(DMT)/DmtFino/DmtTable';
import CustomerList from './bankingServices/money transfer(DMT)/DmtFino/CustomerList';
import DmtTableIserveu from './bankingServices/money transfer(DMT)/DMTIserveu/DmtTable';
import CreateCustomer from './bankingServices/money transfer(DMT)/DmtFino/CreateCustomer';
import CreateCustomerIserveu from './bankingServices/money transfer(DMT)/DMTIserveu/CreateCustomer';
import BeneficiaryList from './bankingServices/money transfer(DMT)/DmtFino/BeneficiaryList';
import DmtTransferIserveu from './bankingServices/money transfer(DMT)/DMTIserveu/DmtTransfer';
import CreateBeneficiary from './bankingServices/money transfer(DMT)/DmtFino/CreateBeneficiary';
import CheckBeneficiaryStatusIserveu from './bankingServices/money transfer(DMT)/DMTIserveu/CheckBeneficiaryStatus';
import DenseTable from './bankingServices/money transfer(DMT)/DmtFino/TransferPage';
import DenseTableIserveu from './bankingServices/money transfer(DMT)/DMTIserveu/TransferPage';
import { useAuthConnect } from 'hooks/useAuth';

export const ConditionalRenderViewCustomerPage = () => {
    useAuthConnect();
    const authToken = localStorage.getItem('AuthToken');
    const dmtType = 'fino';
    const reKyc = localStorage.getItem('reKyc');
    const rekycStatus = localStorage.getItem('rekycStatus');
    const data = { reKyc, rekycStatus };

    if (authToken) {
        if (dmtType === 'iserveu' || dmtType === 'billavenue') {
            return <DmtTableIserveu additionalData={data} />;
        } else {
            return <CustomerList additionalData={data} />;
        }
    }
    else {
        <Navigate to="/unauthorized-section" replace />;
    }
};

export const ConditionalRenderCreateCustomerPage = () => {
    const dmtType = 'fino';

    if (dmtType === 'iserveu' || dmtType === 'billavenue') {
        return <CreateCustomerIserveu />;
    } else {
        return <CreateCustomer />;
    }
};

export const ConditionalRenderViewBeneficiaryPage = () => {
    const dmtType = 'fino';

    if (dmtType === 'iserveu' || dmtType === 'billavenue') {
        return <DmtTransferIserveu />;
    } else {
        return <BeneficiaryList />;
    }
};

export const ConditionalRenderCreateBeneficiaryPage = () => {
    const dmtType = 'fino';

    if (dmtType === 'iserveu' || dmtType === 'billavenue') {
        return <CheckBeneficiaryStatusIserveu />;
    } else {
        return <CreateBeneficiary />;
    }
};

export const ConditionalRenderDmtTransferPage = () => {
    const dmtType = 'fino';

    if (dmtType === 'iserveu' || dmtType === 'billavenue') {
        return <DenseTableIserveu />;
    } else {
        return <DenseTable />;
    }
};
